import { ClinicalExceptionControllerService } from "@9amhealth/openapi";
import { Cubit } from "blac-next";
import { onUserSessionReset } from "src/lib/onUserSessionReset";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { toast } from "src/state/state";

type ClinicalExceptionState = {
  requested: boolean;
  submitting: boolean;
};

const initialState: ClinicalExceptionState = {
  requested: false,
  submitting: false
};

export default class ClinicalExceptionCubit extends Cubit<ClinicalExceptionState> {
  private readonly stopListeningForSessionReset: () => void;

  constructor() {
    super(initialState);
    this.stopListeningForSessionReset = onUserSessionReset(() =>
      this.emit(initialState)
    );
  }

  override _dispose(): void {
    this.stopListeningForSessionReset();
    super._dispose();
  }

  loadRequestedException = async (): Promise<void> => {
    try {
      const response =
        await ClinicalExceptionControllerService.getLatestActiveClinicalExceptionForCurrentUser();
      this.patch({ requested: Boolean(response.data) });
    } catch (error) {
      reportErrorSentry(error);
    }
  };

  /** The backend derives the exception reason from the member's saved questionnaire answers, so no payload is sent. */
  requestException = async (): Promise<void> => {
    if (this.state.submitting || this.state.requested) {
      return;
    }

    this.patch({ submitting: true });
    try {
      await ClinicalExceptionControllerService.storeClinicalExceptionForCurrentUser();
      this.patch({ requested: true, submitting: false });
    } catch (error) {
      this.patch({ submitting: false });
      toast.error("error.generic");
      reportErrorSentry(error);
    }
  };
}
